import { useStateContext } from "../../Contexts/ContextProvider";
import { LoadingOverlay } from "@mantine/core";
import { useSelector } from "react-redux";

const OverlayLoader = () => {
  const { loader } =
    useSelector((state: any) => ({
      loader: state.globalLists?.pageLoader,
    }))
  const { currentPrimaryColor } = useStateContext();

  return (
    <LoadingOverlay visible={loader} zIndex={1000} overlayProps={{ radius: "sm", blur: 0 }} loaderProps={{ color: currentPrimaryColor }} />
  );
};

export default OverlayLoader;